export const BUSINESS_NAME = "Royal Edu Hub";
export const PRIMARY_PHONE = "+91 70341 11684";
export const SECONDARY_PHONE = "+91 87942 56411";
export const PRIMARY_PHONE_TEL = "+917034111684";
export const SECONDARY_PHONE_TEL = "+918794256411";
export const EMAIL = "royaleduhub24@gmail.com";

export const ADDRESS = {
  streetAddressLine1: "Royal Complex, Kaithavana Jn,",
  streetAddressLine2: "Pazhaveedu, Alappuzha,",
  regionLine: "Kerala 688003, India",
  streetAddress: "Royal Complex, Kaithavana Junction, Pazhaveedu",
  locality: "Alappuzha",
  region: "Kerala",
  postalCode: "688003",
  countryCode: "IN",
  countryName: "India",
  googleMapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Royal%20Complex%2C%20Kaithavana%20Jn%2C%20Pazhaveedu%2C%20Alappuzha%2C%20Kerala%20688003%2C%20India",
};

